import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '../types';

const STORAGE_KEY = 'verify-ui-language';

export const getStoredLanguage = (): SupportedLanguage | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return null;
    }

    return SUPPORTED_LANGUAGES.includes(stored as SupportedLanguage)
      ? (stored as SupportedLanguage)
      : null;
  } catch {
    return null;
  }
};

export const setStoredLanguage = (language: SupportedLanguage): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    sessionStorage.setItem(STORAGE_KEY, language);
  } catch {
    // Ignore storage errors (e.g., restricted environments).
  }
};

export const clearStoredLanguage = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ignore storage errors.
  }
};
